import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, User } from 'lucide-react';
export function BlogSection() {
  const posts = [{
    title: 'Understanding Home Healthcare Options in Maryland',
    excerpt: "Navigating the complexities of home healthcare can be challenging. Here's what you need to know...",
    image: 'https://www.harmonyhealthcaremd.com/wp-content/uploads/2024/12/btm5-box1-img.jpg',
    date: 'Oct 12, 2024',
    readTime: '5 min read',
    category: 'Guide'
  }, {
    title: 'The Importance of Compassionate Care for Seniors',
    excerpt: 'Emotional well-being is just as important as physical health. Discover how compassion transforms lives.',
    image: 'https://www.harmonyhealthcaremd.com/wp-content/uploads/2024/12/btm5-box2-img.jpg',
    date: 'Oct 08, 2024',
    readTime: '4 min read',
    category: 'Wellness'
  }, {
    title: 'Tips for Choosing the Right Caregiver for Your Family',
    excerpt: 'Finding the perfect match is crucial for long-term success. We share our expert matching process.',
    image: 'https://www.harmonyhealthcaremd.com/wp-content/uploads/2024/12/btm5-box3-img.jpg',
    date: 'Sep 28, 2024',
    readTime: '6 min read',
    category: 'Advice'
  }];
  return <section id="blog" className="py-24 bg-background-secondary" data-id="element-63">
      <div className="container mx-auto px-6" data-id="element-64">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16" data-id="element-65">
          <div className="max-w-2xl" data-id="element-66">
            <span className="text-primary font-bold tracking-[0.2em] uppercase text-[10px] mb-4 block" data-id="element-67">
              OUR BLOG
            </span>
            <h2 className="text-3xl lg:text-5xl font-heading font-bold leading-tight tracking-tight" data-id="element-68">
              <span className="text-dark-text" data-id="element-69">Latest insights and</span>
              <br data-id="element-70" />
              <span className="text-primary" data-id="element-71">healthcare tips</span>
            </h2>
          </div>
          <div className="flex-shrink-0" data-id="element-72">
            <button className="px-6 py-3 bg-transparent text-dark-text font-semibold rounded-full border-2 border-dark-text hover:bg-dark-text hover:text-white transition-all duration-300 flex items-center gap-2 group text-sm" data-id="element-73">
              View all articles
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-74" />
            </button>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10" data-id="element-75">
          {posts.map((post, index) => <motion.article key={post.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-white rounded-[32px] overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 border border-gray-100" data-id="element-76">
              <div className="relative h-64 overflow-hidden" data-id="element-77">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-78" />
                <div className="absolute top-6 left-6" data-id="element-79">
                  <span className="px-4 py-2 bg-white/90 backdrop-blur-md rounded-full text-xs font-bold text-primary uppercase tracking-wider" data-id="element-80">
                    {post.category}
                  </span>
                </div>
              </div>

              <div className="p-8" data-id="element-81">
                <div className="flex items-center gap-6 text-sm text-body-text mb-6" data-id="element-82">
                  <div className="flex items-center gap-2" data-id="element-83">
                    <Clock className="w-4 h-4" data-id="element-84" />
                    {post.readTime}
                  </div>
                  <div className="flex items-center gap-2" data-id="element-85">
                    <User className="w-4 h-4" data-id="element-86" />
                    By Harmony Team
                  </div>
                </div>

                <h3 className="text-2xl font-heading font-bold text-dark-text mb-4 group-hover:text-primary transition-colors line-clamp-2" data-id="element-87">
                  {post.title}
                </h3>

                <p className="text-body-text mb-8 line-clamp-3 leading-relaxed" data-id="element-88">
                  {post.excerpt}
                </p>

                <div className="flex items-center justify-between pt-6 border-t border-gray-100" data-id="element-89">
                  <span className="text-sm font-medium text-gray-400" data-id="element-90">
                    {post.date}
                  </span>
                  <button className="text-primary font-bold flex items-center gap-2 group/btn" data-id="element-91">
                    Read More
                    <ArrowRight className="w-4 h-4 transition-transform group-hover/btn:translate-x-1" data-id="element-92" />
                  </button>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}